import { render, staticRenderFns } from "./ConfigCreate.vue?vue&type=template&id=5f2c6a0e"
import script from "./ConfigCreate.vue?vue&type=script&lang=js"
export * from "./ConfigCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports